import React from 'react';
import './styles.scss';

import { generateUpdatedField, generateCreatedField, generateOrgReportTemplateUpdatedField } from 'utils/generator';

interface UpdatedCreatedDateFields {
    updated?: string;
    created?: string;
    updatedDate?: string;
    createdDate?: string;
    organizationReportTemplateUpdatedDate?: string | null;
}

interface ModalUpdatedInfoProps<T extends UpdatedCreatedDateFields> {
    item: T;
    hideCreated?: boolean;
    isBFF?: boolean; // The BFF APIs use "updatedDate" & "createdDate" fields combination instead of "updated" & "created"
}

const ModalUpdatedInfo = <T extends UpdatedCreatedDateFields>({
    item,
    hideCreated,
    isBFF,
}: ModalUpdatedInfoProps<T>) => {
    if (item?.created || item?.updated || item?.createdDate || item?.updatedDate)
        return (
            <div className="info-wrapper" data-testid="created-updated-info">
                {item?.organizationReportTemplateUpdatedDate && <p>{generateOrgReportTemplateUpdatedField(item)}</p>}
                {(item?.updated || item?.updatedDate) && (
                    <p>{generateUpdatedField(item, isBFF ? 'updatedDate' : 'updated')}</p>
                )}
                {(item?.created || item?.createdDate) && !hideCreated && (
                    <p>{generateCreatedField(item, isBFF ? 'createdDate' : 'created')}</p>
                )}
            </div>
        );
    return null;
};

export default ModalUpdatedInfo;
